// Actions related to API calls for protocols

import axios from "axios";
import { serverURL } from "../../constants/constants";
import { viewIds } from "../../constants/componentMap";

// Import necessary calls from other files
import {
  calculateStudyProgress,
  setView,
  errorResponse,
  successResponse,
  warningResponse,
  setCameraModal,
  setCreateProtocolMode,
  discardStudy,
} from "../../actions";
import { getImageType } from "../../constants/utilityFunctions";
import { studyFixture } from "../../constants/Fixtures/studyFixture";

import {
  TRAINING_PROTOCOL,
  PresetLocations,
  CUSTOM_PROTOCOL,
} from "../../constants/Fixtures/protocolFixture";

export function fetchProtocolsList() {
  return function (dispatch, getState) {
    let state = getState();
    let req = {
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /get_protocols_list", req);
    dispatch(requestProtcolsList());
    return axios.post(serverURL + "/get_protocols_list", req).then(
      (response) => {
        dispatch(receiveProtocolsList(response.data.protocols));
      },
      (error) => {
        dispatch(resetProtocolsList());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_PROTOCOLS_LIST = "REQUEST_PROTOCOLS_LIST";
export function requestProtcolsList() {
  return {
    type: REQUEST_PROTOCOLS_LIST,
  };
}

export const RECEIVE_PROTOCOLS_LIST = "RECEIVE_PROTOCOLS_LIST";
export function receiveProtocolsList(protocols) {
  return {
    type: RECEIVE_PROTOCOLS_LIST,
    protocols,
  };
}

export const RESET_PROTOCOLS_LIST = "RESET_PROTOCOLS_LIST";
export function resetProtocolsList() {
  return {
    type: RESET_PROTOCOLS_LIST,
  };
}

export function fetchSetProtocol(protocolId, studyId, participantId) {
  return function (dispatch, getState) {
    let state = getState();
    let req = {
      protocolId: protocolId,
      studyId: studyId,
      participantId: participantId,
      encryption: true, // BY DEFAULT STUDIES ARE ENCRYPTED
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /set_protocol ", req);
    // return axios.post(serverURL + "/set_protocol", req).then(
    //   (response) => {
    if (protocolId === "TRAINING_PROTOCOL") {
      dispatch(receiveProtocol(TRAINING_PROTOCOL));
    } else {
      dispatch(
        receiveProtocol(state.availableProtocols.protocolsById[protocolId])
      );
    }

    // dispatch(
    //   setStudySavePath(response.data["filePath"], response.data["wipPath"])
    // );

    // if (!response.data["empty"]) {
    //   dispatch(
    //     warningResponse(
    //       "Unsaved files from previous study are moved to local trash folder"
    //     )
    //   );
    // }
    dispatch(calculateTotalSamplesNeeded());
    dispatch(setView(viewIds.mainApp));
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const RECEIVE_PROTOCOL = "RECEIVE_PROTOCOL";
export function receiveProtocol(setProtocol) {
  return {
    type: RECEIVE_PROTOCOL,
    setProtocol,
  };
}

export const SET_STUDY_SAVE_PATH = "SET_STUDY_SAVE_PATH";
export function setStudySavePath(studySavePath, wipPath = null) {
  let correctedSavePath = studySavePath.replace(/[\\]/g, "/");

  if (
    correctedSavePath.endsWith(".autosave.study") ||
    correctedSavePath.endsWith(".autosave.study.encrypt")
  ) {
    correctedSavePath = correctedSavePath.replace(".autosave", "");
  }
  return {
    type: SET_STUDY_SAVE_PATH,
    studySavePath: correctedSavePath,
    wipPath: wipPath,
  };
}

export const ADD_MAP = "ADD_MAP";
export function addMap(map) {
  return {
    type: ADD_MAP,
    data: map,
  };
}

export function fetchFaceDetection(base64Image) {
  return function (dispatch, getState) {
    // console.log("POST request made for /detect_face, with image");
    dispatch(requestFaceDetection());
    return axios
      .post(serverURL + "/detect_face", { base64Image: base64Image })
      .then(
        (response) => {
          if (response.data.image === "ERROR") {
            dispatch(errorResponse("Face detection failed. Please try again"));
            dispatch(resetFaceDetection());
          } else {
            dispatch(setCameraModal(false, null)); // Close the camera modal
            dispatch(
              receiveFaceDetection({
                ...response.data,
                studyId: getState().studyInfo.id,
              })
            ); // Add face image and geoJSON to redux
          }
        },
        (error) => {
          dispatch(errorResponse(error));
          dispatch(resetFaceDetection());
        }
      );
  };
}

export const RESET_FACE_DETECTION = "RESET_FACE_DETECTION";
export function resetFaceDetection() {
  return {
    type: RESET_FACE_DETECTION,
  };
}

export const REQUEST_FACE_DETECTION = "REQUEST_FACE_DETECTION";
export function requestFaceDetection() {
  return {
    type: REQUEST_FACE_DETECTION,
  };
}

export const RECEIVE_FACE_DETECTION = "RECEIVE_FACE_DETECTION";
export function receiveFaceDetection(data) {
  let imageType = getImageType(data.image);

  return {
    type: RECEIVE_FACE_DETECTION,
    image: data.image,
    regions: data.regions,
    imageType: imageType,
    studyId: data.studyId,
  };
}

// One time action to tally up total samples needed which gets stored in redux store
export function calculateTotalSamplesNeeded() {
  return function (dispatch, getState) {
    const state = getState();
    let totalSamplesNeeded = 0;

    for (let locationId of state.locations.allIds) {
      //for each location thats NOT removed from study
      if (!state.protocol.locations[locationId].removed) {
        for (let acqType of Object.keys(state.protocol.acq_types)) {
          //for each acq types
          const samplesNeeded =
            state.locations.byId[locationId].samplesNeeded[acqType];
          totalSamplesNeeded += samplesNeeded;
        }
      }
    }
    dispatch(setTotalSamplesNeeded(totalSamplesNeeded));
    dispatch(calculateStudyProgress());
  };
}

export const SET_TOTAL_SAMPLES_NEEDED = "SET_TOTAL_SAMPLES_NEEDED";
export function setTotalSamplesNeeded(totalSamplesNeeded) {
  return {
    type: SET_TOTAL_SAMPLES_NEEDED,
    totalSamplesNeeded,
  };
}

export const ADD_CUSTOM_PROTOCOL_TO_REDUX = "ADD_CUSTOM_PROTOCOL_TO_REDUX";
export function addCustomProtocolToRedux(customProtocol) {
  return {
    type: ADD_CUSTOM_PROTOCOL_TO_REDUX,
    customProtocol: customProtocol,
  };
}
// add the locations protocol of the chosen study to redux state

export function saveCustomProtocol(protocolInfo) {
  return function (dispatch, getState) {
    let state = getState();
    let req = {
      customProtocol: {
        ...state.protocol,
        protocolId: protocolInfo.protocolId,
        protocolName: protocolInfo.protocolName,
      },
    };
    console.log("POST request made for /save_custom_protocol ", req);
    // axios.post(serverURL + "/save_custom_protocol", req).then(
    //   (response) => {
    dispatch(addCustomProtocolToRedux(req.customProtocol));
    if (state.utility.mode.createProtocolMode) {
      dispatch(discardStudy("QUIT"));
    }

    //     dispatch(
    //       successResponse(
    //         protocolInfo.protocolName +
    //           " protocol saved to Custom_Protocols folder."
    //       )
    //     );
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export function fetchSetLocalStudyTemplate(studyId, newStudyInfo) {
  return function (dispatch, getState) {
    dispatch(requestSetLocalStudyTemplate());
    let state = getState();
    // let req = {
    //   filepath: filepath,
    //   newStudyInfo: newStudyInfo,
    //   credential: {
    //     username: state.userInfo.username,
    //     password: state.userInfo.password,
    //   },
    //   encryption: true, // BY DEFAULT STUDIES ARE ENCRYPTED
    // };

    console.log("POST request made for /set_local_study_template");
    // return axios.post(serverURL + "/set_local_study_template", req).then(
    //   (response) => {

    if (studyId === studyFixture.study.studyInfo.id) {
      dispatch(receiveProtocol(studyFixture.protocol));

      let study_info = {
        id: newStudyInfo["id"],
        participantId: studyFixture.study.studyInfo["participantId"],
        protocolId: studyFixture.study.studyInfo["protocolId"],
        protocolName: studyFixture.study.studyInfo["protocolName"],
        skinType: "",
        gender: "",
        otherId: "",
        birthYear: "",
        startedAt: newStudyInfo["startedAt"],
        studyDate: newStudyInfo["studyDate"],
      };

      dispatch(receiveTemplate(true, study_info));
      dispatch(calculateTotalSamplesNeeded());
      dispatch(setStudySavePath(studyFixture.study.studyInfo.studySavePath));
    } else {
      let study_info = {
        id: newStudyInfo["id"],
        participantId:
          state.availableStudies.localStudyInfoById[studyId].study.studyInfo[
            "participantId"
          ],
        protocolId:
          state.availableStudies.localStudyInfoById[studyId].study.studyInfo[
            "protocolId"
          ],
        protocolName: studyFixture.study.studyInfo["protocolName"],
        skinType: "",
        gender: "",
        otherId: "",
        birthYear: "",
        startedAt: newStudyInfo["startedAt"],
        studyDate: newStudyInfo["studyDate"],
      };

      dispatch(
        receiveProtocol(
          state.availableStudies.localStudyInfoById[studyId].protocol
        )
      );
      dispatch(receiveTemplate(true, study_info));
      dispatch(calculateTotalSamplesNeeded());
      dispatch(
        setStudySavePath(
          state.availableStudies.localStudyInfoById[studyId].study.studyInfo
            .studySavePath
        )
      );
    }

    //     if (!response.data["empty"]) {
    //       dispatch(
    //         warningResponse(
    //           "Unsaved files from previous study are moved to local trash folder"
    //         )
    //       );
    //     }
    //   },
    //   (error) => {
    //     dispatch(resetTemplate());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export const REQUEST_SET_LOCAL_STUDY_TEMPLATE =
  "REQUEST_SET_LOCAL_STUDY_TEMPLATE";
export function requestSetLocalStudyTemplate() {
  return {
    type: REQUEST_SET_LOCAL_STUDY_TEMPLATE,
  };
}

export const RESET_TEMPLATE = "RESET_TEMPLATE";
export function resetTemplate() {
  return {
    type: RESET_TEMPLATE,
  };
}

export const RECEIVE_TEMPLATE = "RECEIVE_TEMPLATE";
export function receiveTemplate(state, templateReceivedInfo) {
  return {
    type: RECEIVE_TEMPLATE,
    state,
    templateReceivedInfo,
  };
}

export function fetchSetRemoteStudyTemplate(templateStudyId, newStudyInfo) {
  return function (dispatch, getState) {
    dispatch(requestSetRemoteStudyTemplate());
    let state = getState();
    let req = {
      templateStudyId: templateStudyId,
      newStudyInfo: newStudyInfo,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
      encryption: true, // BY DEFAULT STUDIES ARE ENCRYPTED
    };

    console.log("POST request made for /set_remote_study_template", req);
    return axios.post(serverURL + "/set_remote_study_template", req).then(
      (response) => {
        dispatch(receiveProtocol(response.data["protocol"]));
        dispatch(receiveTemplate(true, response.data["info"]));
        dispatch(calculateTotalSamplesNeeded());
        dispatch(
          setStudySavePath(response.data["filePath"], response.data["wipPath"])
        );
        if (!response.data["empty"]) {
          dispatch(
            warningResponse(
              "Unsaved files from previous study are moved to local trash folder"
            )
          );
        }
      },
      (error) => {
        dispatch(resetTemplate());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_SET_REMOTE_STUDY_TEMPLATE =
  "REQUEST_SET_REMOTE_STUDY_TEMPLATE";
export function requestSetRemoteStudyTemplate() {
  return {
    type: REQUEST_SET_REMOTE_STUDY_TEMPLATE,
  };
}

export const SET_TEMPLATE_PROMPT = "SET_TEMPLATE_PROMPT";
export function setTemplatePrompt(templatePrompt) {
  return {
    type: SET_TEMPLATE_PROMPT,
    templatePrompt: templatePrompt,
  };
}

export function fetchCustomProtocolTemplate() {
  return function (dispatch, getState) {
    console.log("GET request made for /get_custom_protocol_template ");
    let state = getState();
    // axios
    //   .post(serverURL + "/get_custom_protocol_template", {
    //     credential: {
    //       username: state.userInfo.username,
    //       password: state.userInfo.password,
    //     },
    //   })
    //   .then(
    //     (response) => {
    dispatch(receiveProtocol(CUSTOM_PROTOCOL));
    // dispatch(receiveProtocolsList(response.data["available_protocols"]));
    dispatch(setCreateProtocolMode(true));
    dispatch(setView(viewIds.customProtocol));
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export function fetchEditExistingParticipantInfo(
  participantInfo,
  updateRemote
) {
  return function (dispatch) {
    let req = {
      participantInfo: participantInfo,
      updateRemote: updateRemote,
    };
    console.log("POST request made for /edit_existing_participant_info ", req);
    axios.post(serverURL + "/edit_existing_participant_info", req).then(
      (response) => {
        if (response.data.warning !== null) {
          dispatch(warningResponse(response.data.warning));
        }
      },
      (error) => dispatch(errorResponse(error))
    );
  };
}
export function fetchPresetLocations(maps) {
  return function (dispatch) {
    dispatch(requestPresetLocations());
    console.log("POST request made for /get_preset_locations/", maps);
    // return axios
    // .post(serverURL + "/get_preset_locations", {
    //   maps: maps,
    // })
    // .then(
    //   (response) => {

    let filteredtPresetLocations = {};

    for (let presetLoc in PresetLocations) {
      console.log(PresetLocations[presetLoc], maps);
      for (let mapId in maps) {
        console.log(mapId);
        if (
          Object.keys(PresetLocations[presetLoc].maps).includes(maps[mapId])
        ) {
          filteredtPresetLocations[presetLoc] = PresetLocations[presetLoc];
        }
      }
    }

    dispatch(receivePresetLocations(filteredtPresetLocations));
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const REQUEST_PRESET_LOCATIONS = "REQUEST_PRESET_LOCATIONS";
export function requestPresetLocations() {
  return {
    type: REQUEST_PRESET_LOCATIONS,
  };
}

export const RECEIVE_PRESET_LOCATIONS = "RECEIVE_PRESET_LOCATIONS";
export function receivePresetLocations(locations) {
  return {
    type: RECEIVE_PRESET_LOCATIONS,
    presetLocations: locations,
  };
}
